import { useEffect, useState, useMemo } from "react";
import { InnBg, blackBusinessman } from "assets/images";

const UserDateTimeDisplay = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => setDate(new Date()), 1000);
    return () => clearInterval(intervalId);
  }, []);

  const formattedDate = useMemo(() => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    const dayOfWeek = days[date.getDay()];
    const month = months[date.getMonth()];
    const dayOfMonth = date.getDate();
    const suffix = getSuffix(dayOfMonth);
    return `${dayOfWeek}, ${dayOfMonth}${suffix} ${month}, ${date.getFullYear()}`;
  }, [date]);

  const formattedTime = useMemo(() => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${formattedMinutes}`;
  }, [date]);

  return (
    <div
      className="h-full lg:h-[194px] w-full mb-4 rounded-2xl  text-white bg-stone-900/60"
      style={{ backgroundImage: `url(${InnBg})` }}
    >
      <div className="bg-black-100 bg-opacity-70 w-full p-6 rounded-2xl h-full flex justify-between">
        <div>
          <p className="font-bold text-lg">Welcome user,</p>
          <p className="font-bold text-[61px] mt-1">{formattedTime}</p>
          <p className="text-[18px] font-normal">{formattedDate}</p>
        </div>
        <div
          className="h-[107px] w-[107px] rounded-full bg-[#c7e8d2] flex items-center justify-center"
          style={{
            backgroundImage: `url(${blackBusinessman})`,
            backgroundRepeat: "no-repeat",
            backgroundPositionX: "center",
            backgroundPositionY: "bottom"
          }}
        />
      </div>
    </div>
  );
};

const getSuffix = (dayOfMonth: number) => {
  if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31) {
    return "st";
  } else if (dayOfMonth === 2 || dayOfMonth === 22) {
    return "nd";
  } else if (dayOfMonth === 3 || dayOfMonth === 23) {
    return "rd";
  } else {
    return "th";
  }
};

export default UserDateTimeDisplay;
